module.exports = __webpack_public_path__ + "static/0031-3d22742e4d123d299581147c2b8fd64d.png";